import React, { useState } from 'react';
import {connect} from 'react-redux';
import { Menu } from 'antd';

import UserDashboard from '../../Dashboard/components/UserDashboard/UserDashboard';
import CaseTableV2 from '../../Case/components/CaseTableV2/CaseTable';
import SearchHistory from '../../Case/components/SearchHistoryV2/SearchHistory';
import UserTable from '../../User/components/UserTableV2/UserTable';
import SubscriptionPlan from '../../Billing/components/SubscriptedPlans/SubscriptedPlan';
import PaymentHistory from '../../Billing/components/PaymentHistory/PaymentHistory';
import UserProfile from '../../User/components/UserProfile/UserProfile';
import Plans from '../../Billing/components/Plans/Plans';
import { FolderOpenFilled, FolderOpenOutlined, HistoryOutlined, InfoCircleOutlined, InfoOutlined, SettingOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';
import CustomIcon from '../../../utils/components/CustomIcon/CustomIcon';

import './Settings.css'

const Settings = (props) => {
  const { currentRole } = props
  const [selectedKey, setSelectedKey] = useState('overview');

  const renderContent = () => {
    if (currentRole.isAnalyst) return <UserProfile {...props} pageTitle='Profile' />

    switch (selectedKey) {
      case 'overview':
        return <UserDashboard {...props} pageTitle='Dashboard' />
      case 'cases':
        return <CaseTableV2 {...props} ownOnly={false} pageTitle='Cases' />
      case 'history':
        return <SearchHistory {...props} ownOnly={false} pageTitle='Search History' />
      case 'users':
        return <UserTable {...props} pageTitle='Users' />
      // case 'billing':
      //   return (<><Plans {...props} pageTitle='Plans'/><SubscriptionPlan {...props} pageTitle='Subscriptions' />
      //     <PaymentHistory {...props} pageTitle='Payment History' /></>)
      case 'account':
        return <UserProfile {...props} pageTitle='Profile' />
      default:
        return <div>Not Found</div>;
    }
  };

  return (
    <div style={{ marginTop: '-24px' }}>
      {!currentRole.isAnalyst && <Menu id="settings-menu-list" mode="horizontal" selectedKeys={[selectedKey]} onClick={(e) => setSelectedKey(e.key)}>
        <Menu.Item key="overview" icon={<CustomIcon name="Info" />}>Overview</Menu.Item>
        <Menu.Item key="cases" icon={<CustomIcon name="OpenFolder" />}>Cases</Menu.Item>
        <Menu.Item key="history" icon={<CustomIcon name="History" />}>History</Menu.Item>
        <Menu.Item key="users" icon={<CustomIcon name="UserCircleSingle" />}>Users</Menu.Item>
        {/* <Menu.Item key="billing">Billing</Menu.Item> */}
        <Menu.Item key="account" icon={<CustomIcon name="AccountSettings" />}>Account</Menu.Item>
      </Menu>}
      <div style={{ marginTop: '24px' }}>{renderContent()}</div>  
    </div>
  );
};

const mapStateToProps = state => {
  return {
    loggedInUser: state.auth.loggedInUser,
    currentRole: state.auth.currentRole
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
};

const SettingsComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings);

export default SettingsComponent;
